import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import '../../Styles/Header.css'
import Appbar from '../../Component/NavPannel/Appbar';
import RebalancingRoutes from '../../Component/Layouts/Rebalancing';


const mdTheme = createTheme();

function Mainbalance() {

  return (
    <ThemeProvider theme={mdTheme}>
       <Box sx={{ display: "flex", height: "100vh" }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Strategies Management" />
        <RebalancingRoutes />
      </Box>
    </ThemeProvider>
  );
}

export default function Rebalancing() {
  return <Mainbalance />
}